export default __webpack_public_path__ + "static/media/all.f02b8628.png";